import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

export const themes = {
  default: ({ color = COLORS.GRAY_DARKER, colorBg = COLORS.WHITE, isDisabled }) => {
    const colorsClasses = isDisabled
      ? 'bg-gray-light cursor-default pointer-events-none text-gray-medium'
      : `bg-${colorBg} focus:bg-${colorBg}-active hover:bg-${colorBg}-active text-${color}`;
    return {
      thRoot: classnames(
        colorsClasses,
        'reset-button block flex items-center justify-center leading-none rounded-tiny text-sm transition-colors',
      ),
      thIconName: ICONS.BOLDER_ARROW_FORTH_LEFT,
      thLabel: 'a11y',
    };
  },
};
